import { render, staticRenderFns } from "./PlaceChangeActivationType.vue?vue&type=template&id=157ceb64&"
import script from "./PlaceChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./PlaceChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports